// extracted by mini-css-extract-plugin
module.exports = {"heroCard":"LoansHeroFormSection_heroCard__tXyRo","heroCalculator":"LoansHeroFormSection_heroCalculator__ewjPu"};